// source: playbook/playbook.proto
/**
 * @fileoverview
 * @enhanceable
 * @suppress {missingRequire} reports error on implicit type usages.
 * @suppress {messageConventions} JS Compiler reports an error if a variable or
 *     field starts with 'MSG_' and isn't a translatable message.
 * @public
 */
// GENERATED CODE -- DO NOT EDIT!
/* eslint-disable */
// @ts-nocheck

var jspb = require('google-protobuf');
var goog = jspb;
var global = (function() { return this || window || global || self || Function('return this')(); }).call(null);

var common_model_pb = require('../common/model_pb.js');
goog.object.extend(proto, common_model_pb);
var chatcontext_chatcontext_pb = require('../chatcontext/chatcontext_pb.js');
goog.object.extend(proto, chatcontext_chatcontext_pb);
var google_protobuf_empty_pb = require('google-protobuf/google/protobuf/empty_pb.js');
goog.object.extend(proto, google_protobuf_empty_pb);
goog.exportSymbol('proto.playbook.CreatePlaybookRequest', null, global);
goog.exportSymbol('proto.playbook.CreatePlaybookRunRequest', null, global);
goog.exportSymbol('proto.playbook.FavoriteRequest', null, global);
goog.exportSymbol('proto.playbook.IsHeadlessChatRequest', null, global);
goog.exportSymbol('proto.playbook.IsHeadlessChatResponse', null, global);
goog.exportSymbol('proto.playbook.ListPlaybookRunsInternalRequest', null, global);
goog.exportSymbol('proto.playbook.ListPlaybooksInternalRequest', null, global);
goog.exportSymbol('proto.playbook.ListPlaybooksRequest', null, global);
goog.exportSymbol('proto.playbook.MakePrivateRequest', null, global);
goog.exportSymbol('proto.playbook.ObjectIdRequest', null, global);
goog.exportSymbol('proto.playbook.Playbook', null, global);
goog.exportSymbol('proto.playbook.PlaybookContext', null, global);
goog.exportSymbol('proto.playbook.PlaybookInputs', null, global);
goog.exportSymbol('proto.playbook.PlaybookParameter', null, global);
goog.exportSymbol('proto.playbook.PlaybookPrompt', null, global);
goog.exportSymbol('proto.playbook.PlaybookResponse', null, global);
goog.exportSymbol('proto.playbook.PlaybookRun', null, global);
goog.exportSymbol('proto.playbook.PlaybookRunParameter', null, global);
goog.exportSymbol('proto.playbook.PlaybookRunPromptParameter', null, global);
goog.exportSymbol('proto.playbook.PlaybookRunResponse', null, global);
goog.exportSymbol('proto.playbook.PlaybookRunsResponse', null, global);
goog.exportSymbol('proto.playbook.PlaybooksResponse', null, global);
goog.exportSymbol('proto.playbook.RunPlaybookRequest', null, global);
goog.exportSymbol('proto.playbook.RunPlaybookResponse', null, global);
goog.exportSymbol('proto.playbook.TrusteroAgentType', null, global);
goog.exportSymbol('proto.playbook.UpdatePlaybookRequest', null, global);
goog.exportSymbol('proto.playbook.UploadFilesRequest', null, global);
goog.exportSymbol('proto.playbook.UploadFilesResponse', null, global);
goog.exportSymbol('proto.playbook.ValueSource', null, global);
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.PlaybookParameter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.playbook.PlaybookParameter.repeatedFields_, null);
};
goog.inherits(proto.playbook.PlaybookParameter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.PlaybookParameter.displayName = 'proto.playbook.PlaybookParameter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.PlaybookContext = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.playbook.PlaybookContext, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.PlaybookContext.displayName = 'proto.playbook.PlaybookContext';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.PlaybookPrompt = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.playbook.PlaybookPrompt.repeatedFields_, null);
};
goog.inherits(proto.playbook.PlaybookPrompt, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.PlaybookPrompt.displayName = 'proto.playbook.PlaybookPrompt';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.Playbook = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.playbook.Playbook.repeatedFields_, null);
};
goog.inherits(proto.playbook.Playbook, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.Playbook.displayName = 'proto.playbook.Playbook';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.PlaybookRunParameter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.playbook.PlaybookRunParameter.repeatedFields_, null);
};
goog.inherits(proto.playbook.PlaybookRunParameter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.PlaybookRunParameter.displayName = 'proto.playbook.PlaybookRunParameter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.PlaybookRunPromptParameter = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.playbook.PlaybookRunPromptParameter.repeatedFields_, null);
};
goog.inherits(proto.playbook.PlaybookRunPromptParameter, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.PlaybookRunPromptParameter.displayName = 'proto.playbook.PlaybookRunPromptParameter';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.PlaybookRun = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.playbook.PlaybookRun, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.PlaybookRun.displayName = 'proto.playbook.PlaybookRun';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.ObjectIdRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.playbook.ObjectIdRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.ObjectIdRequest.displayName = 'proto.playbook.ObjectIdRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.CreatePlaybookRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.playbook.CreatePlaybookRequest.repeatedFields_, null);
};
goog.inherits(proto.playbook.CreatePlaybookRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.CreatePlaybookRequest.displayName = 'proto.playbook.CreatePlaybookRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.UpdatePlaybookRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.playbook.UpdatePlaybookRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.UpdatePlaybookRequest.displayName = 'proto.playbook.UpdatePlaybookRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.PlaybookInputs = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.playbook.PlaybookInputs.repeatedFields_, null);
};
goog.inherits(proto.playbook.PlaybookInputs, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.PlaybookInputs.displayName = 'proto.playbook.PlaybookInputs';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.CreatePlaybookRunRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.playbook.CreatePlaybookRunRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.CreatePlaybookRunRequest.displayName = 'proto.playbook.CreatePlaybookRunRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.ListPlaybooksRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.playbook.ListPlaybooksRequest.repeatedFields_, null);
};
goog.inherits(proto.playbook.ListPlaybooksRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.ListPlaybooksRequest.displayName = 'proto.playbook.ListPlaybooksRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.ListPlaybooksInternalRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.playbook.ListPlaybooksInternalRequest.repeatedFields_, null);
};
goog.inherits(proto.playbook.ListPlaybooksInternalRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.ListPlaybooksInternalRequest.displayName = 'proto.playbook.ListPlaybooksInternalRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.ListPlaybookRunsInternalRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.playbook.ListPlaybookRunsInternalRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.ListPlaybookRunsInternalRequest.displayName = 'proto.playbook.ListPlaybookRunsInternalRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.PlaybookResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.playbook.PlaybookResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.PlaybookResponse.displayName = 'proto.playbook.PlaybookResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.PlaybooksResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.playbook.PlaybooksResponse.repeatedFields_, null);
};
goog.inherits(proto.playbook.PlaybooksResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.PlaybooksResponse.displayName = 'proto.playbook.PlaybooksResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.PlaybookRunResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.playbook.PlaybookRunResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.PlaybookRunResponse.displayName = 'proto.playbook.PlaybookRunResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.PlaybookRunsResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.playbook.PlaybookRunsResponse.repeatedFields_, null);
};
goog.inherits(proto.playbook.PlaybookRunsResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.PlaybookRunsResponse.displayName = 'proto.playbook.PlaybookRunsResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.FavoriteRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.playbook.FavoriteRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.FavoriteRequest.displayName = 'proto.playbook.FavoriteRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.RunPlaybookRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.playbook.RunPlaybookRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.RunPlaybookRequest.displayName = 'proto.playbook.RunPlaybookRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.RunPlaybookResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.playbook.RunPlaybookResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.RunPlaybookResponse.displayName = 'proto.playbook.RunPlaybookResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.IsHeadlessChatRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.playbook.IsHeadlessChatRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.IsHeadlessChatRequest.displayName = 'proto.playbook.IsHeadlessChatRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.IsHeadlessChatResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.playbook.IsHeadlessChatResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.IsHeadlessChatResponse.displayName = 'proto.playbook.IsHeadlessChatResponse';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.MakePrivateRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.playbook.MakePrivateRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.MakePrivateRequest.displayName = 'proto.playbook.MakePrivateRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.UploadFilesRequest = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, proto.playbook.UploadFilesRequest.repeatedFields_, null);
};
goog.inherits(proto.playbook.UploadFilesRequest, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.UploadFilesRequest.displayName = 'proto.playbook.UploadFilesRequest';
}
/**
 * Generated by JsPbCodeGenerator.
 * @param {Array=} opt_data Optional initial data array, typically from a
 * server response, or constructed directly in Javascript. The array is used
 * in place and becomes part of the constructed object. It is not cloned.
 * If no data is provided, the constructed object will be empty, but still
 * valid.
 * @extends {jspb.Message}
 * @constructor
 */
proto.playbook.UploadFilesResponse = function(opt_data) {
  jspb.Message.initialize(this, opt_data, 0, -1, null, null);
};
goog.inherits(proto.playbook.UploadFilesResponse, jspb.Message);
if (goog.DEBUG && !COMPILED) {
  /**
   * @public
   * @override
   */
  proto.playbook.UploadFilesResponse.displayName = 'proto.playbook.UploadFilesResponse';
}

/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.playbook.PlaybookParameter.repeatedFields_ = [5];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.PlaybookParameter.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.PlaybookParameter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.PlaybookParameter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybookParameter.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    parameterType: jspb.Message.getFieldWithDefault(msg, 2, 0),
    valueSource: jspb.Message.getFieldWithDefault(msg, 3, 0),
    allowmultiplevalues: jspb.Message.getBooleanFieldWithDefault(msg, 4, false),
    valuesList: (f = jspb.Message.getRepeatedField(msg, 5)) == null ? undefined : f,
    description: jspb.Message.getFieldWithDefault(msg, 6, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.PlaybookParameter}
 */
proto.playbook.PlaybookParameter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.PlaybookParameter;
  return proto.playbook.PlaybookParameter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.PlaybookParameter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.PlaybookParameter}
 */
proto.playbook.PlaybookParameter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {!proto.common.MODEL_TYPE} */ (reader.readEnum());
      msg.setParameterType(value);
      break;
    case 3:
      var value = /** @type {!proto.playbook.ValueSource} */ (reader.readEnum());
      msg.setValueSource(value);
      break;
    case 4:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setAllowmultiplevalues(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.PlaybookParameter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.PlaybookParameter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.PlaybookParameter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybookParameter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getParameterType();
  if (f !== 0.0) {
    writer.writeEnum(
      2,
      f
    );
  }
  f = message.getValueSource();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getAllowmultiplevalues();
  if (f) {
    writer.writeBool(
      4,
      f
    );
  }
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      5,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.playbook.PlaybookParameter.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.PlaybookParameter} returns this
 */
proto.playbook.PlaybookParameter.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional common.MODEL_TYPE parameter_type = 2;
 * @return {!proto.common.MODEL_TYPE}
 */
proto.playbook.PlaybookParameter.prototype.getParameterType = function() {
  return /** @type {!proto.common.MODEL_TYPE} */ (jspb.Message.getFieldWithDefault(this, 2, 0));
};


/**
 * @param {!proto.common.MODEL_TYPE} value
 * @return {!proto.playbook.PlaybookParameter} returns this
 */
proto.playbook.PlaybookParameter.prototype.setParameterType = function(value) {
  return jspb.Message.setProto3EnumField(this, 2, value);
};


/**
 * optional ValueSource value_source = 3;
 * @return {!proto.playbook.ValueSource}
 */
proto.playbook.PlaybookParameter.prototype.getValueSource = function() {
  return /** @type {!proto.playbook.ValueSource} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.playbook.ValueSource} value
 * @return {!proto.playbook.PlaybookParameter} returns this
 */
proto.playbook.PlaybookParameter.prototype.setValueSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * optional bool allowMultipleValues = 4;
 * @return {boolean}
 */
proto.playbook.PlaybookParameter.prototype.getAllowmultiplevalues = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 4, false));
};


/**
 * @param {boolean} value
 * @return {!proto.playbook.PlaybookParameter} returns this
 */
proto.playbook.PlaybookParameter.prototype.setAllowmultiplevalues = function(value) {
  return jspb.Message.setProto3BooleanField(this, 4, value);
};


/**
 * repeated string values = 5;
 * @return {!Array<string>}
 */
proto.playbook.PlaybookParameter.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 5));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.playbook.PlaybookParameter} returns this
 */
proto.playbook.PlaybookParameter.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 5, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.playbook.PlaybookParameter} returns this
 */
proto.playbook.PlaybookParameter.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 5, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.playbook.PlaybookParameter} returns this
 */
proto.playbook.PlaybookParameter.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};


/**
 * optional string description = 6;
 * @return {string}
 */
proto.playbook.PlaybookParameter.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.PlaybookParameter} returns this
 */
proto.playbook.PlaybookParameter.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.PlaybookContext.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.PlaybookContext.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.PlaybookContext} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybookContext.toObject = function(includeInstance, msg) {
  var f, obj = {
    dataSource: jspb.Message.getFieldWithDefault(msg, 1, 0),
    includeAll: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.PlaybookContext}
 */
proto.playbook.PlaybookContext.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.PlaybookContext;
  return proto.playbook.PlaybookContext.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.PlaybookContext} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.PlaybookContext}
 */
proto.playbook.PlaybookContext.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {!proto.chatcontext.ChatContextSourceType} */ (reader.readEnum());
      msg.setDataSource(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeAll(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.PlaybookContext.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.PlaybookContext.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.PlaybookContext} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybookContext.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getDataSource();
  if (f !== 0.0) {
    writer.writeEnum(
      1,
      f
    );
  }
  f = message.getIncludeAll();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional chatcontext.ChatContextSourceType data_source = 1;
 * @return {!proto.chatcontext.ChatContextSourceType}
 */
proto.playbook.PlaybookContext.prototype.getDataSource = function() {
  return /** @type {!proto.chatcontext.ChatContextSourceType} */ (jspb.Message.getFieldWithDefault(this, 1, 0));
};


/**
 * @param {!proto.chatcontext.ChatContextSourceType} value
 * @return {!proto.playbook.PlaybookContext} returns this
 */
proto.playbook.PlaybookContext.prototype.setDataSource = function(value) {
  return jspb.Message.setProto3EnumField(this, 1, value);
};


/**
 * optional bool include_all = 2;
 * @return {boolean}
 */
proto.playbook.PlaybookContext.prototype.getIncludeAll = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.playbook.PlaybookContext} returns this
 */
proto.playbook.PlaybookContext.prototype.setIncludeAll = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.playbook.PlaybookPrompt.repeatedFields_ = [4];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.PlaybookPrompt.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.PlaybookPrompt.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.PlaybookPrompt} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybookPrompt.toObject = function(includeInstance, msg) {
  var f, obj = {
    name: jspb.Message.getFieldWithDefault(msg, 1, ""),
    prompt: jspb.Message.getFieldWithDefault(msg, 2, ""),
    agent: jspb.Message.getFieldWithDefault(msg, 3, 0),
    parametersList: jspb.Message.toObjectList(msg.getParametersList(),
    proto.playbook.PlaybookParameter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.PlaybookPrompt}
 */
proto.playbook.PlaybookPrompt.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.PlaybookPrompt;
  return proto.playbook.PlaybookPrompt.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.PlaybookPrompt} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.PlaybookPrompt}
 */
proto.playbook.PlaybookPrompt.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPrompt(value);
      break;
    case 3:
      var value = /** @type {!proto.playbook.TrusteroAgentType} */ (reader.readEnum());
      msg.setAgent(value);
      break;
    case 4:
      var value = new proto.playbook.PlaybookParameter;
      reader.readMessage(value,proto.playbook.PlaybookParameter.deserializeBinaryFromReader);
      msg.addParameters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.PlaybookPrompt.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.PlaybookPrompt.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.PlaybookPrompt} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybookPrompt.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPrompt();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getAgent();
  if (f !== 0.0) {
    writer.writeEnum(
      3,
      f
    );
  }
  f = message.getParametersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      4,
      f,
      proto.playbook.PlaybookParameter.serializeBinaryToWriter
    );
  }
};


/**
 * optional string name = 1;
 * @return {string}
 */
proto.playbook.PlaybookPrompt.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.PlaybookPrompt} returns this
 */
proto.playbook.PlaybookPrompt.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string prompt = 2;
 * @return {string}
 */
proto.playbook.PlaybookPrompt.prototype.getPrompt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.PlaybookPrompt} returns this
 */
proto.playbook.PlaybookPrompt.prototype.setPrompt = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional TrusteroAgentType agent = 3;
 * @return {!proto.playbook.TrusteroAgentType}
 */
proto.playbook.PlaybookPrompt.prototype.getAgent = function() {
  return /** @type {!proto.playbook.TrusteroAgentType} */ (jspb.Message.getFieldWithDefault(this, 3, 0));
};


/**
 * @param {!proto.playbook.TrusteroAgentType} value
 * @return {!proto.playbook.PlaybookPrompt} returns this
 */
proto.playbook.PlaybookPrompt.prototype.setAgent = function(value) {
  return jspb.Message.setProto3EnumField(this, 3, value);
};


/**
 * repeated PlaybookParameter parameters = 4;
 * @return {!Array<!proto.playbook.PlaybookParameter>}
 */
proto.playbook.PlaybookPrompt.prototype.getParametersList = function() {
  return /** @type{!Array<!proto.playbook.PlaybookParameter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.playbook.PlaybookParameter, 4));
};


/**
 * @param {!Array<!proto.playbook.PlaybookParameter>} value
 * @return {!proto.playbook.PlaybookPrompt} returns this
*/
proto.playbook.PlaybookPrompt.prototype.setParametersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 4, value);
};


/**
 * @param {!proto.playbook.PlaybookParameter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.playbook.PlaybookParameter}
 */
proto.playbook.PlaybookPrompt.prototype.addParameters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 4, opt_value, proto.playbook.PlaybookParameter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.playbook.PlaybookPrompt} returns this
 */
proto.playbook.PlaybookPrompt.prototype.clearParametersList = function() {
  return this.setParametersList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.playbook.Playbook.repeatedFields_ = [11,14,15];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.Playbook.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.Playbook.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.Playbook} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.Playbook.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    isGlobal: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    accountId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 4, 0),
    updatedAt: jspb.Message.getFieldWithDefault(msg, 5, 0),
    updatedBy: jspb.Message.getFieldWithDefault(msg, 6, ""),
    name: jspb.Message.getFieldWithDefault(msg, 7, ""),
    category: jspb.Message.getFieldWithDefault(msg, 8, ""),
    description: jspb.Message.getFieldWithDefault(msg, 9, ""),
    machineDescription: jspb.Message.getFieldWithDefault(msg, 10, ""),
    keywordsList: (f = jspb.Message.getRepeatedField(msg, 11)) == null ? undefined : f,
    isFavorite: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    includeInPlanning: jspb.Message.getBooleanFieldWithDefault(msg, 13, false),
    promptsList: jspb.Message.toObjectList(msg.getPromptsList(),
    proto.playbook.PlaybookPrompt.toObject, includeInstance),
    contextsList: jspb.Message.toObjectList(msg.getContextsList(),
    proto.playbook.PlaybookContext.toObject, includeInstance),
    isGettingStarted: jspb.Message.getBooleanFieldWithDefault(msg, 16, false),
    leadPrompt: jspb.Message.getFieldWithDefault(msg, 17, ""),
    isPrivate: jspb.Message.getBooleanFieldWithDefault(msg, 18, false),
    createdBy: jspb.Message.getFieldWithDefault(msg, 19, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.Playbook}
 */
proto.playbook.Playbook.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.Playbook;
  return proto.playbook.Playbook.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.Playbook} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.Playbook}
 */
proto.playbook.Playbook.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsGlobal(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 4:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setUpdatedAt(value);
      break;
    case 6:
      var value = /** @type {string} */ (reader.readString());
      msg.setUpdatedBy(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 8:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 9:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 10:
      var value = /** @type {string} */ (reader.readString());
      msg.setMachineDescription(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.addKeywords(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsFavorite(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeInPlanning(value);
      break;
    case 14:
      var value = new proto.playbook.PlaybookPrompt;
      reader.readMessage(value,proto.playbook.PlaybookPrompt.deserializeBinaryFromReader);
      msg.addPrompts(value);
      break;
    case 15:
      var value = new proto.playbook.PlaybookContext;
      reader.readMessage(value,proto.playbook.PlaybookContext.deserializeBinaryFromReader);
      msg.addContexts(value);
      break;
    case 16:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsGettingStarted(value);
      break;
    case 17:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeadPrompt(value);
      break;
    case 18:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPrivate(value);
      break;
    case 19:
      var value = /** @type {string} */ (reader.readString());
      msg.setCreatedBy(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.Playbook.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.Playbook.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.Playbook} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.Playbook.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIsGlobal();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      4,
      f
    );
  }
  f = message.getUpdatedAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
  f = message.getUpdatedBy();
  if (f.length > 0) {
    writer.writeString(
      6,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      7,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      8,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      9,
      f
    );
  }
  f = message.getMachineDescription();
  if (f.length > 0) {
    writer.writeString(
      10,
      f
    );
  }
  f = message.getKeywordsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      11,
      f
    );
  }
  f = message.getIsFavorite();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getIncludeInPlanning();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
  f = message.getPromptsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      14,
      f,
      proto.playbook.PlaybookPrompt.serializeBinaryToWriter
    );
  }
  f = message.getContextsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      15,
      f,
      proto.playbook.PlaybookContext.serializeBinaryToWriter
    );
  }
  f = message.getIsGettingStarted();
  if (f) {
    writer.writeBool(
      16,
      f
    );
  }
  f = message.getLeadPrompt();
  if (f.length > 0) {
    writer.writeString(
      17,
      f
    );
  }
  f = message.getIsPrivate();
  if (f) {
    writer.writeBool(
      18,
      f
    );
  }
  f = message.getCreatedBy();
  if (f.length > 0) {
    writer.writeString(
      19,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.playbook.Playbook.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.Playbook} returns this
 */
proto.playbook.Playbook.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool is_global = 2;
 * @return {boolean}
 */
proto.playbook.Playbook.prototype.getIsGlobal = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.playbook.Playbook} returns this
 */
proto.playbook.Playbook.prototype.setIsGlobal = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string account_id = 3;
 * @return {string}
 */
proto.playbook.Playbook.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.Playbook} returns this
 */
proto.playbook.Playbook.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional int64 created_at = 4;
 * @return {number}
 */
proto.playbook.Playbook.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 4, 0));
};


/**
 * @param {number} value
 * @return {!proto.playbook.Playbook} returns this
 */
proto.playbook.Playbook.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 4, value);
};


/**
 * optional int64 updated_at = 5;
 * @return {number}
 */
proto.playbook.Playbook.prototype.getUpdatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.playbook.Playbook} returns this
 */
proto.playbook.Playbook.prototype.setUpdatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};


/**
 * optional string updated_by = 6;
 * @return {string}
 */
proto.playbook.Playbook.prototype.getUpdatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 6, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.Playbook} returns this
 */
proto.playbook.Playbook.prototype.setUpdatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 6, value);
};


/**
 * optional string name = 7;
 * @return {string}
 */
proto.playbook.Playbook.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 7, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.Playbook} returns this
 */
proto.playbook.Playbook.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 7, value);
};


/**
 * optional string category = 8;
 * @return {string}
 */
proto.playbook.Playbook.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 8, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.Playbook} returns this
 */
proto.playbook.Playbook.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 8, value);
};


/**
 * optional string description = 9;
 * @return {string}
 */
proto.playbook.Playbook.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 9, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.Playbook} returns this
 */
proto.playbook.Playbook.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 9, value);
};


/**
 * optional string machine_description = 10;
 * @return {string}
 */
proto.playbook.Playbook.prototype.getMachineDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 10, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.Playbook} returns this
 */
proto.playbook.Playbook.prototype.setMachineDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 10, value);
};


/**
 * repeated string keywords = 11;
 * @return {!Array<string>}
 */
proto.playbook.Playbook.prototype.getKeywordsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 11));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.playbook.Playbook} returns this
 */
proto.playbook.Playbook.prototype.setKeywordsList = function(value) {
  return jspb.Message.setField(this, 11, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.playbook.Playbook} returns this
 */
proto.playbook.Playbook.prototype.addKeywords = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 11, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.playbook.Playbook} returns this
 */
proto.playbook.Playbook.prototype.clearKeywordsList = function() {
  return this.setKeywordsList([]);
};


/**
 * optional bool is_favorite = 12;
 * @return {boolean}
 */
proto.playbook.Playbook.prototype.getIsFavorite = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.playbook.Playbook} returns this
 */
proto.playbook.Playbook.prototype.setIsFavorite = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool include_in_planning = 13;
 * @return {boolean}
 */
proto.playbook.Playbook.prototype.getIncludeInPlanning = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.playbook.Playbook} returns this
 */
proto.playbook.Playbook.prototype.setIncludeInPlanning = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};


/**
 * repeated PlaybookPrompt prompts = 14;
 * @return {!Array<!proto.playbook.PlaybookPrompt>}
 */
proto.playbook.Playbook.prototype.getPromptsList = function() {
  return /** @type{!Array<!proto.playbook.PlaybookPrompt>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.playbook.PlaybookPrompt, 14));
};


/**
 * @param {!Array<!proto.playbook.PlaybookPrompt>} value
 * @return {!proto.playbook.Playbook} returns this
*/
proto.playbook.Playbook.prototype.setPromptsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 14, value);
};


/**
 * @param {!proto.playbook.PlaybookPrompt=} opt_value
 * @param {number=} opt_index
 * @return {!proto.playbook.PlaybookPrompt}
 */
proto.playbook.Playbook.prototype.addPrompts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 14, opt_value, proto.playbook.PlaybookPrompt, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.playbook.Playbook} returns this
 */
proto.playbook.Playbook.prototype.clearPromptsList = function() {
  return this.setPromptsList([]);
};


/**
 * repeated PlaybookContext contexts = 15;
 * @return {!Array<!proto.playbook.PlaybookContext>}
 */
proto.playbook.Playbook.prototype.getContextsList = function() {
  return /** @type{!Array<!proto.playbook.PlaybookContext>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.playbook.PlaybookContext, 15));
};


/**
 * @param {!Array<!proto.playbook.PlaybookContext>} value
 * @return {!proto.playbook.Playbook} returns this
*/
proto.playbook.Playbook.prototype.setContextsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 15, value);
};


/**
 * @param {!proto.playbook.PlaybookContext=} opt_value
 * @param {number=} opt_index
 * @return {!proto.playbook.PlaybookContext}
 */
proto.playbook.Playbook.prototype.addContexts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 15, opt_value, proto.playbook.PlaybookContext, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.playbook.Playbook} returns this
 */
proto.playbook.Playbook.prototype.clearContextsList = function() {
  return this.setContextsList([]);
};


/**
 * optional bool is_getting_started = 16;
 * @return {boolean}
 */
proto.playbook.Playbook.prototype.getIsGettingStarted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 16, false));
};


/**
 * @param {boolean} value
 * @return {!proto.playbook.Playbook} returns this
 */
proto.playbook.Playbook.prototype.setIsGettingStarted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 16, value);
};


/**
 * optional string lead_prompt = 17;
 * @return {string}
 */
proto.playbook.Playbook.prototype.getLeadPrompt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 17, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.Playbook} returns this
 */
proto.playbook.Playbook.prototype.setLeadPrompt = function(value) {
  return jspb.Message.setProto3StringField(this, 17, value);
};


/**
 * optional bool is_private = 18;
 * @return {boolean}
 */
proto.playbook.Playbook.prototype.getIsPrivate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 18, false));
};


/**
 * @param {boolean} value
 * @return {!proto.playbook.Playbook} returns this
 */
proto.playbook.Playbook.prototype.setIsPrivate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 18, value);
};


/**
 * optional string created_by = 19;
 * @return {string}
 */
proto.playbook.Playbook.prototype.getCreatedBy = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 19, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.Playbook} returns this
 */
proto.playbook.Playbook.prototype.setCreatedBy = function(value) {
  return jspb.Message.setProto3StringField(this, 19, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.playbook.PlaybookRunParameter.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.PlaybookRunParameter.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.PlaybookRunParameter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.PlaybookRunParameter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybookRunParameter.toObject = function(includeInstance, msg) {
  var f, obj = {
    parameterName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    valuesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.PlaybookRunParameter}
 */
proto.playbook.PlaybookRunParameter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.PlaybookRunParameter;
  return proto.playbook.PlaybookRunParameter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.PlaybookRunParameter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.PlaybookRunParameter}
 */
proto.playbook.PlaybookRunParameter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setParameterName(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addValues(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.PlaybookRunParameter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.PlaybookRunParameter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.PlaybookRunParameter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybookRunParameter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getParameterName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getValuesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
};


/**
 * optional string parameter_name = 1;
 * @return {string}
 */
proto.playbook.PlaybookRunParameter.prototype.getParameterName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.PlaybookRunParameter} returns this
 */
proto.playbook.PlaybookRunParameter.prototype.setParameterName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string values = 2;
 * @return {!Array<string>}
 */
proto.playbook.PlaybookRunParameter.prototype.getValuesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.playbook.PlaybookRunParameter} returns this
 */
proto.playbook.PlaybookRunParameter.prototype.setValuesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.playbook.PlaybookRunParameter} returns this
 */
proto.playbook.PlaybookRunParameter.prototype.addValues = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.playbook.PlaybookRunParameter} returns this
 */
proto.playbook.PlaybookRunParameter.prototype.clearValuesList = function() {
  return this.setValuesList([]);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.playbook.PlaybookRunPromptParameter.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.PlaybookRunPromptParameter.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.PlaybookRunPromptParameter.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.PlaybookRunPromptParameter} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybookRunPromptParameter.toObject = function(includeInstance, msg) {
  var f, obj = {
    promptName: jspb.Message.getFieldWithDefault(msg, 1, ""),
    parametersList: jspb.Message.toObjectList(msg.getParametersList(),
    proto.playbook.PlaybookRunParameter.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.PlaybookRunPromptParameter}
 */
proto.playbook.PlaybookRunPromptParameter.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.PlaybookRunPromptParameter;
  return proto.playbook.PlaybookRunPromptParameter.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.PlaybookRunPromptParameter} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.PlaybookRunPromptParameter}
 */
proto.playbook.PlaybookRunPromptParameter.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPromptName(value);
      break;
    case 2:
      var value = new proto.playbook.PlaybookRunParameter;
      reader.readMessage(value,proto.playbook.PlaybookRunParameter.deserializeBinaryFromReader);
      msg.addParameters(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.PlaybookRunPromptParameter.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.PlaybookRunPromptParameter.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.PlaybookRunPromptParameter} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybookRunPromptParameter.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPromptName();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getParametersList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.playbook.PlaybookRunParameter.serializeBinaryToWriter
    );
  }
};


/**
 * optional string prompt_name = 1;
 * @return {string}
 */
proto.playbook.PlaybookRunPromptParameter.prototype.getPromptName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.PlaybookRunPromptParameter} returns this
 */
proto.playbook.PlaybookRunPromptParameter.prototype.setPromptName = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated PlaybookRunParameter parameters = 2;
 * @return {!Array<!proto.playbook.PlaybookRunParameter>}
 */
proto.playbook.PlaybookRunPromptParameter.prototype.getParametersList = function() {
  return /** @type{!Array<!proto.playbook.PlaybookRunParameter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.playbook.PlaybookRunParameter, 2));
};


/**
 * @param {!Array<!proto.playbook.PlaybookRunParameter>} value
 * @return {!proto.playbook.PlaybookRunPromptParameter} returns this
*/
proto.playbook.PlaybookRunPromptParameter.prototype.setParametersList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.playbook.PlaybookRunParameter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.playbook.PlaybookRunParameter}
 */
proto.playbook.PlaybookRunPromptParameter.prototype.addParameters = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.playbook.PlaybookRunParameter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.playbook.PlaybookRunPromptParameter} returns this
 */
proto.playbook.PlaybookRunPromptParameter.prototype.clearParametersList = function() {
  return this.setParametersList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.PlaybookRun.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.PlaybookRun.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.PlaybookRun} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybookRun.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    playbookId: jspb.Message.getFieldWithDefault(msg, 3, ""),
    chatId: jspb.Message.getFieldWithDefault(msg, 4, ""),
    createdAt: jspb.Message.getFieldWithDefault(msg, 5, 0)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.PlaybookRun}
 */
proto.playbook.PlaybookRun.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.PlaybookRun;
  return proto.playbook.PlaybookRun.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.PlaybookRun} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.PlaybookRun}
 */
proto.playbook.PlaybookRun.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaybookId(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    case 5:
      var value = /** @type {number} */ (reader.readInt64());
      msg.setCreatedAt(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.PlaybookRun.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.PlaybookRun.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.PlaybookRun} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybookRun.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getPlaybookId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getCreatedAt();
  if (f !== 0) {
    writer.writeInt64(
      5,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.playbook.PlaybookRun.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.PlaybookRun} returns this
 */
proto.playbook.PlaybookRun.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.playbook.PlaybookRun.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.PlaybookRun} returns this
 */
proto.playbook.PlaybookRun.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string playbook_id = 3;
 * @return {string}
 */
proto.playbook.PlaybookRun.prototype.getPlaybookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.PlaybookRun} returns this
 */
proto.playbook.PlaybookRun.prototype.setPlaybookId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string chat_id = 4;
 * @return {string}
 */
proto.playbook.PlaybookRun.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.PlaybookRun} returns this
 */
proto.playbook.PlaybookRun.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional int64 created_at = 5;
 * @return {number}
 */
proto.playbook.PlaybookRun.prototype.getCreatedAt = function() {
  return /** @type {number} */ (jspb.Message.getFieldWithDefault(this, 5, 0));
};


/**
 * @param {number} value
 * @return {!proto.playbook.PlaybookRun} returns this
 */
proto.playbook.PlaybookRun.prototype.setCreatedAt = function(value) {
  return jspb.Message.setProto3IntField(this, 5, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.ObjectIdRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.ObjectIdRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.ObjectIdRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.ObjectIdRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    id: jspb.Message.getFieldWithDefault(msg, 1, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.ObjectIdRequest}
 */
proto.playbook.ObjectIdRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.ObjectIdRequest;
  return proto.playbook.ObjectIdRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.ObjectIdRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.ObjectIdRequest}
 */
proto.playbook.ObjectIdRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.ObjectIdRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.ObjectIdRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.ObjectIdRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.ObjectIdRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
};


/**
 * optional string id = 1;
 * @return {string}
 */
proto.playbook.ObjectIdRequest.prototype.getId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.ObjectIdRequest} returns this
 */
proto.playbook.ObjectIdRequest.prototype.setId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.playbook.CreatePlaybookRequest.repeatedFields_ = [7,8,9];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.CreatePlaybookRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.CreatePlaybookRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.CreatePlaybookRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.CreatePlaybookRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    name: jspb.Message.getFieldWithDefault(msg, 2, ""),
    category: jspb.Message.getFieldWithDefault(msg, 3, ""),
    description: jspb.Message.getFieldWithDefault(msg, 4, ""),
    machineDescription: jspb.Message.getFieldWithDefault(msg, 5, ""),
    includeInPlanning: jspb.Message.getBooleanFieldWithDefault(msg, 6, false),
    keywordsList: (f = jspb.Message.getRepeatedField(msg, 7)) == null ? undefined : f,
    promptsList: jspb.Message.toObjectList(msg.getPromptsList(),
    proto.playbook.PlaybookPrompt.toObject, includeInstance),
    contextsList: jspb.Message.toObjectList(msg.getContextsList(),
    proto.playbook.PlaybookContext.toObject, includeInstance),
    isGettingStarted: jspb.Message.getBooleanFieldWithDefault(msg, 10, false),
    leadPrompt: jspb.Message.getFieldWithDefault(msg, 11, ""),
    isPrivate: jspb.Message.getBooleanFieldWithDefault(msg, 12, false),
    isVisibleInUi: jspb.Message.getBooleanFieldWithDefault(msg, 13, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.CreatePlaybookRequest}
 */
proto.playbook.CreatePlaybookRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.CreatePlaybookRequest;
  return proto.playbook.CreatePlaybookRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.CreatePlaybookRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.CreatePlaybookRequest}
 */
proto.playbook.CreatePlaybookRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setName(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setCategory(value);
      break;
    case 4:
      var value = /** @type {string} */ (reader.readString());
      msg.setDescription(value);
      break;
    case 5:
      var value = /** @type {string} */ (reader.readString());
      msg.setMachineDescription(value);
      break;
    case 6:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeInPlanning(value);
      break;
    case 7:
      var value = /** @type {string} */ (reader.readString());
      msg.addKeywords(value);
      break;
    case 8:
      var value = new proto.playbook.PlaybookPrompt;
      reader.readMessage(value,proto.playbook.PlaybookPrompt.deserializeBinaryFromReader);
      msg.addPrompts(value);
      break;
    case 9:
      var value = new proto.playbook.PlaybookContext;
      reader.readMessage(value,proto.playbook.PlaybookContext.deserializeBinaryFromReader);
      msg.addContexts(value);
      break;
    case 10:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsGettingStarted(value);
      break;
    case 11:
      var value = /** @type {string} */ (reader.readString());
      msg.setLeadPrompt(value);
      break;
    case 12:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPrivate(value);
      break;
    case 13:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsVisibleInUi(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.CreatePlaybookRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.CreatePlaybookRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.CreatePlaybookRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.CreatePlaybookRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getName();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getCategory();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
  f = message.getDescription();
  if (f.length > 0) {
    writer.writeString(
      4,
      f
    );
  }
  f = message.getMachineDescription();
  if (f.length > 0) {
    writer.writeString(
      5,
      f
    );
  }
  f = message.getIncludeInPlanning();
  if (f) {
    writer.writeBool(
      6,
      f
    );
  }
  f = message.getKeywordsList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      7,
      f
    );
  }
  f = message.getPromptsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      8,
      f,
      proto.playbook.PlaybookPrompt.serializeBinaryToWriter
    );
  }
  f = message.getContextsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      9,
      f,
      proto.playbook.PlaybookContext.serializeBinaryToWriter
    );
  }
  f = message.getIsGettingStarted();
  if (f) {
    writer.writeBool(
      10,
      f
    );
  }
  f = message.getLeadPrompt();
  if (f.length > 0) {
    writer.writeString(
      11,
      f
    );
  }
  f = message.getIsPrivate();
  if (f) {
    writer.writeBool(
      12,
      f
    );
  }
  f = message.getIsVisibleInUi();
  if (f) {
    writer.writeBool(
      13,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.playbook.CreatePlaybookRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.CreatePlaybookRequest} returns this
 */
proto.playbook.CreatePlaybookRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string name = 2;
 * @return {string}
 */
proto.playbook.CreatePlaybookRequest.prototype.getName = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.CreatePlaybookRequest} returns this
 */
proto.playbook.CreatePlaybookRequest.prototype.setName = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string category = 3;
 * @return {string}
 */
proto.playbook.CreatePlaybookRequest.prototype.getCategory = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.CreatePlaybookRequest} returns this
 */
proto.playbook.CreatePlaybookRequest.prototype.setCategory = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};


/**
 * optional string description = 4;
 * @return {string}
 */
proto.playbook.CreatePlaybookRequest.prototype.getDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 4, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.CreatePlaybookRequest} returns this
 */
proto.playbook.CreatePlaybookRequest.prototype.setDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 4, value);
};


/**
 * optional string machine_description = 5;
 * @return {string}
 */
proto.playbook.CreatePlaybookRequest.prototype.getMachineDescription = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 5, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.CreatePlaybookRequest} returns this
 */
proto.playbook.CreatePlaybookRequest.prototype.setMachineDescription = function(value) {
  return jspb.Message.setProto3StringField(this, 5, value);
};


/**
 * optional bool include_in_planning = 6;
 * @return {boolean}
 */
proto.playbook.CreatePlaybookRequest.prototype.getIncludeInPlanning = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 6, false));
};


/**
 * @param {boolean} value
 * @return {!proto.playbook.CreatePlaybookRequest} returns this
 */
proto.playbook.CreatePlaybookRequest.prototype.setIncludeInPlanning = function(value) {
  return jspb.Message.setProto3BooleanField(this, 6, value);
};


/**
 * repeated string keywords = 7;
 * @return {!Array<string>}
 */
proto.playbook.CreatePlaybookRequest.prototype.getKeywordsList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 7));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.playbook.CreatePlaybookRequest} returns this
 */
proto.playbook.CreatePlaybookRequest.prototype.setKeywordsList = function(value) {
  return jspb.Message.setField(this, 7, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.playbook.CreatePlaybookRequest} returns this
 */
proto.playbook.CreatePlaybookRequest.prototype.addKeywords = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 7, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.playbook.CreatePlaybookRequest} returns this
 */
proto.playbook.CreatePlaybookRequest.prototype.clearKeywordsList = function() {
  return this.setKeywordsList([]);
};


/**
 * repeated PlaybookPrompt prompts = 8;
 * @return {!Array<!proto.playbook.PlaybookPrompt>}
 */
proto.playbook.CreatePlaybookRequest.prototype.getPromptsList = function() {
  return /** @type{!Array<!proto.playbook.PlaybookPrompt>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.playbook.PlaybookPrompt, 8));
};


/**
 * @param {!Array<!proto.playbook.PlaybookPrompt>} value
 * @return {!proto.playbook.CreatePlaybookRequest} returns this
*/
proto.playbook.CreatePlaybookRequest.prototype.setPromptsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 8, value);
};


/**
 * @param {!proto.playbook.PlaybookPrompt=} opt_value
 * @param {number=} opt_index
 * @return {!proto.playbook.PlaybookPrompt}
 */
proto.playbook.CreatePlaybookRequest.prototype.addPrompts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 8, opt_value, proto.playbook.PlaybookPrompt, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.playbook.CreatePlaybookRequest} returns this
 */
proto.playbook.CreatePlaybookRequest.prototype.clearPromptsList = function() {
  return this.setPromptsList([]);
};


/**
 * repeated PlaybookContext contexts = 9;
 * @return {!Array<!proto.playbook.PlaybookContext>}
 */
proto.playbook.CreatePlaybookRequest.prototype.getContextsList = function() {
  return /** @type{!Array<!proto.playbook.PlaybookContext>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.playbook.PlaybookContext, 9));
};


/**
 * @param {!Array<!proto.playbook.PlaybookContext>} value
 * @return {!proto.playbook.CreatePlaybookRequest} returns this
*/
proto.playbook.CreatePlaybookRequest.prototype.setContextsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 9, value);
};


/**
 * @param {!proto.playbook.PlaybookContext=} opt_value
 * @param {number=} opt_index
 * @return {!proto.playbook.PlaybookContext}
 */
proto.playbook.CreatePlaybookRequest.prototype.addContexts = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 9, opt_value, proto.playbook.PlaybookContext, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.playbook.CreatePlaybookRequest} returns this
 */
proto.playbook.CreatePlaybookRequest.prototype.clearContextsList = function() {
  return this.setContextsList([]);
};


/**
 * optional bool is_getting_started = 10;
 * @return {boolean}
 */
proto.playbook.CreatePlaybookRequest.prototype.getIsGettingStarted = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 10, false));
};


/**
 * @param {boolean} value
 * @return {!proto.playbook.CreatePlaybookRequest} returns this
 */
proto.playbook.CreatePlaybookRequest.prototype.setIsGettingStarted = function(value) {
  return jspb.Message.setProto3BooleanField(this, 10, value);
};


/**
 * optional string lead_prompt = 11;
 * @return {string}
 */
proto.playbook.CreatePlaybookRequest.prototype.getLeadPrompt = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 11, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.CreatePlaybookRequest} returns this
 */
proto.playbook.CreatePlaybookRequest.prototype.setLeadPrompt = function(value) {
  return jspb.Message.setProto3StringField(this, 11, value);
};


/**
 * optional bool is_private = 12;
 * @return {boolean}
 */
proto.playbook.CreatePlaybookRequest.prototype.getIsPrivate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 12, false));
};


/**
 * @param {boolean} value
 * @return {!proto.playbook.CreatePlaybookRequest} returns this
 */
proto.playbook.CreatePlaybookRequest.prototype.setIsPrivate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 12, value);
};


/**
 * optional bool is_visible_in_ui = 13;
 * @return {boolean}
 */
proto.playbook.CreatePlaybookRequest.prototype.getIsVisibleInUi = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 13, false));
};


/**
 * @param {boolean} value
 * @return {!proto.playbook.CreatePlaybookRequest} returns this
 */
proto.playbook.CreatePlaybookRequest.prototype.setIsVisibleInUi = function(value) {
  return jspb.Message.setProto3BooleanField(this, 13, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.UpdatePlaybookRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.UpdatePlaybookRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.UpdatePlaybookRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.UpdatePlaybookRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    playbook: (f = msg.getPlaybook()) && proto.playbook.Playbook.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.UpdatePlaybookRequest}
 */
proto.playbook.UpdatePlaybookRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.UpdatePlaybookRequest;
  return proto.playbook.UpdatePlaybookRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.UpdatePlaybookRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.UpdatePlaybookRequest}
 */
proto.playbook.UpdatePlaybookRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.playbook.Playbook;
      reader.readMessage(value,proto.playbook.Playbook.deserializeBinaryFromReader);
      msg.setPlaybook(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.UpdatePlaybookRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.UpdatePlaybookRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.UpdatePlaybookRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.UpdatePlaybookRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlaybook();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.playbook.Playbook.serializeBinaryToWriter
    );
  }
};


/**
 * optional Playbook playbook = 1;
 * @return {?proto.playbook.Playbook}
 */
proto.playbook.UpdatePlaybookRequest.prototype.getPlaybook = function() {
  return /** @type{?proto.playbook.Playbook} */ (
    jspb.Message.getWrapperField(this, proto.playbook.Playbook, 1));
};


/**
 * @param {?proto.playbook.Playbook|undefined} value
 * @return {!proto.playbook.UpdatePlaybookRequest} returns this
*/
proto.playbook.UpdatePlaybookRequest.prototype.setPlaybook = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.playbook.UpdatePlaybookRequest} returns this
 */
proto.playbook.UpdatePlaybookRequest.prototype.clearPlaybook = function() {
  return this.setPlaybook(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.playbook.UpdatePlaybookRequest.prototype.hasPlaybook = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.playbook.PlaybookInputs.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.PlaybookInputs.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.PlaybookInputs.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.PlaybookInputs} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybookInputs.toObject = function(includeInstance, msg) {
  var f, obj = {
    playbookId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    promptParameterOverridesList: jspb.Message.toObjectList(msg.getPromptParameterOverridesList(),
    proto.playbook.PlaybookRunPromptParameter.toObject, includeInstance),
    generateEndSummary: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.PlaybookInputs}
 */
proto.playbook.PlaybookInputs.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.PlaybookInputs;
  return proto.playbook.PlaybookInputs.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.PlaybookInputs} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.PlaybookInputs}
 */
proto.playbook.PlaybookInputs.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaybookId(value);
      break;
    case 2:
      var value = new proto.playbook.PlaybookRunPromptParameter;
      reader.readMessage(value,proto.playbook.PlaybookRunPromptParameter.deserializeBinaryFromReader);
      msg.addPromptParameterOverrides(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setGenerateEndSummary(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.PlaybookInputs.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.PlaybookInputs.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.PlaybookInputs} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybookInputs.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlaybookId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPromptParameterOverridesList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      2,
      f,
      proto.playbook.PlaybookRunPromptParameter.serializeBinaryToWriter
    );
  }
  f = message.getGenerateEndSummary();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string playbook_id = 1;
 * @return {string}
 */
proto.playbook.PlaybookInputs.prototype.getPlaybookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.PlaybookInputs} returns this
 */
proto.playbook.PlaybookInputs.prototype.setPlaybookId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated PlaybookRunPromptParameter prompt_parameter_overrides = 2;
 * @return {!Array<!proto.playbook.PlaybookRunPromptParameter>}
 */
proto.playbook.PlaybookInputs.prototype.getPromptParameterOverridesList = function() {
  return /** @type{!Array<!proto.playbook.PlaybookRunPromptParameter>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.playbook.PlaybookRunPromptParameter, 2));
};


/**
 * @param {!Array<!proto.playbook.PlaybookRunPromptParameter>} value
 * @return {!proto.playbook.PlaybookInputs} returns this
*/
proto.playbook.PlaybookInputs.prototype.setPromptParameterOverridesList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 2, value);
};


/**
 * @param {!proto.playbook.PlaybookRunPromptParameter=} opt_value
 * @param {number=} opt_index
 * @return {!proto.playbook.PlaybookRunPromptParameter}
 */
proto.playbook.PlaybookInputs.prototype.addPromptParameterOverrides = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 2, opt_value, proto.playbook.PlaybookRunPromptParameter, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.playbook.PlaybookInputs} returns this
 */
proto.playbook.PlaybookInputs.prototype.clearPromptParameterOverridesList = function() {
  return this.setPromptParameterOverridesList([]);
};


/**
 * optional bool generate_end_summary = 3;
 * @return {boolean}
 */
proto.playbook.PlaybookInputs.prototype.getGenerateEndSummary = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.playbook.PlaybookInputs} returns this
 */
proto.playbook.PlaybookInputs.prototype.setGenerateEndSummary = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.CreatePlaybookRunRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.CreatePlaybookRunRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.CreatePlaybookRunRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.CreatePlaybookRunRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    playbookId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    accountId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    chatId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.CreatePlaybookRunRequest}
 */
proto.playbook.CreatePlaybookRunRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.CreatePlaybookRunRequest;
  return proto.playbook.CreatePlaybookRunRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.CreatePlaybookRunRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.CreatePlaybookRunRequest}
 */
proto.playbook.CreatePlaybookRunRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaybookId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.CreatePlaybookRunRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.CreatePlaybookRunRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.CreatePlaybookRunRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.CreatePlaybookRunRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlaybookId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string playbook_id = 1;
 * @return {string}
 */
proto.playbook.CreatePlaybookRunRequest.prototype.getPlaybookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.CreatePlaybookRunRequest} returns this
 */
proto.playbook.CreatePlaybookRunRequest.prototype.setPlaybookId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string account_id = 2;
 * @return {string}
 */
proto.playbook.CreatePlaybookRunRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.CreatePlaybookRunRequest} returns this
 */
proto.playbook.CreatePlaybookRunRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string chat_id = 3;
 * @return {string}
 */
proto.playbook.CreatePlaybookRunRequest.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.CreatePlaybookRunRequest} returns this
 */
proto.playbook.CreatePlaybookRunRequest.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.playbook.ListPlaybooksRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.ListPlaybooksRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.ListPlaybooksRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.ListPlaybooksRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.ListPlaybooksRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    categoriesList: (f = jspb.Message.getRepeatedField(msg, 1)) == null ? undefined : f,
    includeGlobalPlaybooks: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.ListPlaybooksRequest}
 */
proto.playbook.ListPlaybooksRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.ListPlaybooksRequest;
  return proto.playbook.ListPlaybooksRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.ListPlaybooksRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.ListPlaybooksRequest}
 */
proto.playbook.ListPlaybooksRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.addCategories(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeGlobalPlaybooks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.ListPlaybooksRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.ListPlaybooksRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.ListPlaybooksRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.ListPlaybooksRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      1,
      f
    );
  }
  f = message.getIncludeGlobalPlaybooks();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * repeated string categories = 1;
 * @return {!Array<string>}
 */
proto.playbook.ListPlaybooksRequest.prototype.getCategoriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 1));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.playbook.ListPlaybooksRequest} returns this
 */
proto.playbook.ListPlaybooksRequest.prototype.setCategoriesList = function(value) {
  return jspb.Message.setField(this, 1, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.playbook.ListPlaybooksRequest} returns this
 */
proto.playbook.ListPlaybooksRequest.prototype.addCategories = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 1, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.playbook.ListPlaybooksRequest} returns this
 */
proto.playbook.ListPlaybooksRequest.prototype.clearCategoriesList = function() {
  return this.setCategoriesList([]);
};


/**
 * optional bool include_global_playbooks = 2;
 * @return {boolean}
 */
proto.playbook.ListPlaybooksRequest.prototype.getIncludeGlobalPlaybooks = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.playbook.ListPlaybooksRequest} returns this
 */
proto.playbook.ListPlaybooksRequest.prototype.setIncludeGlobalPlaybooks = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.playbook.ListPlaybooksInternalRequest.repeatedFields_ = [2];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.ListPlaybooksInternalRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.ListPlaybooksInternalRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.ListPlaybooksInternalRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.ListPlaybooksInternalRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    categoriesList: (f = jspb.Message.getRepeatedField(msg, 2)) == null ? undefined : f,
    includeGlobalPlaybooks: jspb.Message.getBooleanFieldWithDefault(msg, 3, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.ListPlaybooksInternalRequest}
 */
proto.playbook.ListPlaybooksInternalRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.ListPlaybooksInternalRequest;
  return proto.playbook.ListPlaybooksInternalRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.ListPlaybooksInternalRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.ListPlaybooksInternalRequest}
 */
proto.playbook.ListPlaybooksInternalRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.addCategories(value);
      break;
    case 3:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIncludeGlobalPlaybooks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.ListPlaybooksInternalRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.ListPlaybooksInternalRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.ListPlaybooksInternalRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.ListPlaybooksInternalRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getCategoriesList();
  if (f.length > 0) {
    writer.writeRepeatedString(
      2,
      f
    );
  }
  f = message.getIncludeGlobalPlaybooks();
  if (f) {
    writer.writeBool(
      3,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.playbook.ListPlaybooksInternalRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.ListPlaybooksInternalRequest} returns this
 */
proto.playbook.ListPlaybooksInternalRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * repeated string categories = 2;
 * @return {!Array<string>}
 */
proto.playbook.ListPlaybooksInternalRequest.prototype.getCategoriesList = function() {
  return /** @type {!Array<string>} */ (jspb.Message.getRepeatedField(this, 2));
};


/**
 * @param {!Array<string>} value
 * @return {!proto.playbook.ListPlaybooksInternalRequest} returns this
 */
proto.playbook.ListPlaybooksInternalRequest.prototype.setCategoriesList = function(value) {
  return jspb.Message.setField(this, 2, value || []);
};


/**
 * @param {string} value
 * @param {number=} opt_index
 * @return {!proto.playbook.ListPlaybooksInternalRequest} returns this
 */
proto.playbook.ListPlaybooksInternalRequest.prototype.addCategories = function(value, opt_index) {
  return jspb.Message.addToRepeatedField(this, 2, value, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.playbook.ListPlaybooksInternalRequest} returns this
 */
proto.playbook.ListPlaybooksInternalRequest.prototype.clearCategoriesList = function() {
  return this.setCategoriesList([]);
};


/**
 * optional bool include_global_playbooks = 3;
 * @return {boolean}
 */
proto.playbook.ListPlaybooksInternalRequest.prototype.getIncludeGlobalPlaybooks = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 3, false));
};


/**
 * @param {boolean} value
 * @return {!proto.playbook.ListPlaybooksInternalRequest} returns this
 */
proto.playbook.ListPlaybooksInternalRequest.prototype.setIncludeGlobalPlaybooks = function(value) {
  return jspb.Message.setProto3BooleanField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.ListPlaybookRunsInternalRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.ListPlaybookRunsInternalRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.ListPlaybookRunsInternalRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.ListPlaybookRunsInternalRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    playbookId: jspb.Message.getFieldWithDefault(msg, 2, ""),
    chatId: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.ListPlaybookRunsInternalRequest}
 */
proto.playbook.ListPlaybookRunsInternalRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.ListPlaybookRunsInternalRequest;
  return proto.playbook.ListPlaybookRunsInternalRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.ListPlaybookRunsInternalRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.ListPlaybookRunsInternalRequest}
 */
proto.playbook.ListPlaybookRunsInternalRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaybookId(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.ListPlaybookRunsInternalRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.ListPlaybookRunsInternalRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.ListPlaybookRunsInternalRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.ListPlaybookRunsInternalRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getPlaybookId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.playbook.ListPlaybookRunsInternalRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.ListPlaybookRunsInternalRequest} returns this
 */
proto.playbook.ListPlaybookRunsInternalRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string playbook_id = 2;
 * @return {string}
 */
proto.playbook.ListPlaybookRunsInternalRequest.prototype.getPlaybookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.ListPlaybookRunsInternalRequest} returns this
 */
proto.playbook.ListPlaybookRunsInternalRequest.prototype.setPlaybookId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};


/**
 * optional string chat_id = 3;
 * @return {string}
 */
proto.playbook.ListPlaybookRunsInternalRequest.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.ListPlaybookRunsInternalRequest} returns this
 */
proto.playbook.ListPlaybookRunsInternalRequest.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.PlaybookResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.PlaybookResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.PlaybookResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybookResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    playbook: (f = msg.getPlaybook()) && proto.playbook.Playbook.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.PlaybookResponse}
 */
proto.playbook.PlaybookResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.PlaybookResponse;
  return proto.playbook.PlaybookResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.PlaybookResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.PlaybookResponse}
 */
proto.playbook.PlaybookResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.playbook.Playbook;
      reader.readMessage(value,proto.playbook.Playbook.deserializeBinaryFromReader);
      msg.setPlaybook(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.PlaybookResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.PlaybookResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.PlaybookResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybookResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlaybook();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.playbook.Playbook.serializeBinaryToWriter
    );
  }
};


/**
 * optional Playbook playbook = 1;
 * @return {?proto.playbook.Playbook}
 */
proto.playbook.PlaybookResponse.prototype.getPlaybook = function() {
  return /** @type{?proto.playbook.Playbook} */ (
    jspb.Message.getWrapperField(this, proto.playbook.Playbook, 1));
};


/**
 * @param {?proto.playbook.Playbook|undefined} value
 * @return {!proto.playbook.PlaybookResponse} returns this
*/
proto.playbook.PlaybookResponse.prototype.setPlaybook = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.playbook.PlaybookResponse} returns this
 */
proto.playbook.PlaybookResponse.prototype.clearPlaybook = function() {
  return this.setPlaybook(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.playbook.PlaybookResponse.prototype.hasPlaybook = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.playbook.PlaybooksResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.PlaybooksResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.PlaybooksResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.PlaybooksResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybooksResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    playbooksList: jspb.Message.toObjectList(msg.getPlaybooksList(),
    proto.playbook.Playbook.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.PlaybooksResponse}
 */
proto.playbook.PlaybooksResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.PlaybooksResponse;
  return proto.playbook.PlaybooksResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.PlaybooksResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.PlaybooksResponse}
 */
proto.playbook.PlaybooksResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.playbook.Playbook;
      reader.readMessage(value,proto.playbook.Playbook.deserializeBinaryFromReader);
      msg.addPlaybooks(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.PlaybooksResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.PlaybooksResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.PlaybooksResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybooksResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlaybooksList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.playbook.Playbook.serializeBinaryToWriter
    );
  }
};


/**
 * repeated Playbook playbooks = 1;
 * @return {!Array<!proto.playbook.Playbook>}
 */
proto.playbook.PlaybooksResponse.prototype.getPlaybooksList = function() {
  return /** @type{!Array<!proto.playbook.Playbook>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.playbook.Playbook, 1));
};


/**
 * @param {!Array<!proto.playbook.Playbook>} value
 * @return {!proto.playbook.PlaybooksResponse} returns this
*/
proto.playbook.PlaybooksResponse.prototype.setPlaybooksList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.playbook.Playbook=} opt_value
 * @param {number=} opt_index
 * @return {!proto.playbook.Playbook}
 */
proto.playbook.PlaybooksResponse.prototype.addPlaybooks = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.playbook.Playbook, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.playbook.PlaybooksResponse} returns this
 */
proto.playbook.PlaybooksResponse.prototype.clearPlaybooksList = function() {
  return this.setPlaybooksList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.PlaybookRunResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.PlaybookRunResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.PlaybookRunResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybookRunResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    playbookRun: (f = msg.getPlaybookRun()) && proto.playbook.PlaybookRun.toObject(includeInstance, f)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.PlaybookRunResponse}
 */
proto.playbook.PlaybookRunResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.PlaybookRunResponse;
  return proto.playbook.PlaybookRunResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.PlaybookRunResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.PlaybookRunResponse}
 */
proto.playbook.PlaybookRunResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.playbook.PlaybookRun;
      reader.readMessage(value,proto.playbook.PlaybookRun.deserializeBinaryFromReader);
      msg.setPlaybookRun(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.PlaybookRunResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.PlaybookRunResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.PlaybookRunResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybookRunResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlaybookRun();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.playbook.PlaybookRun.serializeBinaryToWriter
    );
  }
};


/**
 * optional PlaybookRun playbook_run = 1;
 * @return {?proto.playbook.PlaybookRun}
 */
proto.playbook.PlaybookRunResponse.prototype.getPlaybookRun = function() {
  return /** @type{?proto.playbook.PlaybookRun} */ (
    jspb.Message.getWrapperField(this, proto.playbook.PlaybookRun, 1));
};


/**
 * @param {?proto.playbook.PlaybookRun|undefined} value
 * @return {!proto.playbook.PlaybookRunResponse} returns this
*/
proto.playbook.PlaybookRunResponse.prototype.setPlaybookRun = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.playbook.PlaybookRunResponse} returns this
 */
proto.playbook.PlaybookRunResponse.prototype.clearPlaybookRun = function() {
  return this.setPlaybookRun(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.playbook.PlaybookRunResponse.prototype.hasPlaybookRun = function() {
  return jspb.Message.getField(this, 1) != null;
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.playbook.PlaybookRunsResponse.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.PlaybookRunsResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.PlaybookRunsResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.PlaybookRunsResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybookRunsResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    playbookRunsList: jspb.Message.toObjectList(msg.getPlaybookRunsList(),
    proto.playbook.PlaybookRun.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.PlaybookRunsResponse}
 */
proto.playbook.PlaybookRunsResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.PlaybookRunsResponse;
  return proto.playbook.PlaybookRunsResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.PlaybookRunsResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.PlaybookRunsResponse}
 */
proto.playbook.PlaybookRunsResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.playbook.PlaybookRun;
      reader.readMessage(value,proto.playbook.PlaybookRun.deserializeBinaryFromReader);
      msg.addPlaybookRuns(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.PlaybookRunsResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.PlaybookRunsResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.PlaybookRunsResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.PlaybookRunsResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlaybookRunsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      proto.playbook.PlaybookRun.serializeBinaryToWriter
    );
  }
};


/**
 * repeated PlaybookRun playbook_runs = 1;
 * @return {!Array<!proto.playbook.PlaybookRun>}
 */
proto.playbook.PlaybookRunsResponse.prototype.getPlaybookRunsList = function() {
  return /** @type{!Array<!proto.playbook.PlaybookRun>} */ (
    jspb.Message.getRepeatedWrapperField(this, proto.playbook.PlaybookRun, 1));
};


/**
 * @param {!Array<!proto.playbook.PlaybookRun>} value
 * @return {!proto.playbook.PlaybookRunsResponse} returns this
*/
proto.playbook.PlaybookRunsResponse.prototype.setPlaybookRunsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.playbook.PlaybookRun=} opt_value
 * @param {number=} opt_index
 * @return {!proto.playbook.PlaybookRun}
 */
proto.playbook.PlaybookRunsResponse.prototype.addPlaybookRuns = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.playbook.PlaybookRun, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.playbook.PlaybookRunsResponse} returns this
 */
proto.playbook.PlaybookRunsResponse.prototype.clearPlaybookRunsList = function() {
  return this.setPlaybookRunsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.FavoriteRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.FavoriteRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.FavoriteRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.FavoriteRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    playbookId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    favorite: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.FavoriteRequest}
 */
proto.playbook.FavoriteRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.FavoriteRequest;
  return proto.playbook.FavoriteRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.FavoriteRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.FavoriteRequest}
 */
proto.playbook.FavoriteRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaybookId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setFavorite(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.FavoriteRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.FavoriteRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.FavoriteRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.FavoriteRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlaybookId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getFavorite();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string playbook_id = 1;
 * @return {string}
 */
proto.playbook.FavoriteRequest.prototype.getPlaybookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.FavoriteRequest} returns this
 */
proto.playbook.FavoriteRequest.prototype.setPlaybookId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool favorite = 2;
 * @return {boolean}
 */
proto.playbook.FavoriteRequest.prototype.getFavorite = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.playbook.FavoriteRequest} returns this
 */
proto.playbook.FavoriteRequest.prototype.setFavorite = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.RunPlaybookRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.RunPlaybookRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.RunPlaybookRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.RunPlaybookRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    playbookInputs: (f = msg.getPlaybookInputs()) && proto.playbook.PlaybookInputs.toObject(includeInstance, f),
    isVisibleInChat: jspb.Message.getBooleanFieldWithDefault(msg, 2, false),
    optionalQuestion: jspb.Message.getFieldWithDefault(msg, 3, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.RunPlaybookRequest}
 */
proto.playbook.RunPlaybookRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.RunPlaybookRequest;
  return proto.playbook.RunPlaybookRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.RunPlaybookRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.RunPlaybookRequest}
 */
proto.playbook.RunPlaybookRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new proto.playbook.PlaybookInputs;
      reader.readMessage(value,proto.playbook.PlaybookInputs.deserializeBinaryFromReader);
      msg.setPlaybookInputs(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsVisibleInChat(value);
      break;
    case 3:
      var value = /** @type {string} */ (reader.readString());
      msg.setOptionalQuestion(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.RunPlaybookRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.RunPlaybookRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.RunPlaybookRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.RunPlaybookRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlaybookInputs();
  if (f != null) {
    writer.writeMessage(
      1,
      f,
      proto.playbook.PlaybookInputs.serializeBinaryToWriter
    );
  }
  f = message.getIsVisibleInChat();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
  f = message.getOptionalQuestion();
  if (f.length > 0) {
    writer.writeString(
      3,
      f
    );
  }
};


/**
 * optional PlaybookInputs playbook_inputs = 1;
 * @return {?proto.playbook.PlaybookInputs}
 */
proto.playbook.RunPlaybookRequest.prototype.getPlaybookInputs = function() {
  return /** @type{?proto.playbook.PlaybookInputs} */ (
    jspb.Message.getWrapperField(this, proto.playbook.PlaybookInputs, 1));
};


/**
 * @param {?proto.playbook.PlaybookInputs|undefined} value
 * @return {!proto.playbook.RunPlaybookRequest} returns this
*/
proto.playbook.RunPlaybookRequest.prototype.setPlaybookInputs = function(value) {
  return jspb.Message.setWrapperField(this, 1, value);
};


/**
 * Clears the message field making it undefined.
 * @return {!proto.playbook.RunPlaybookRequest} returns this
 */
proto.playbook.RunPlaybookRequest.prototype.clearPlaybookInputs = function() {
  return this.setPlaybookInputs(undefined);
};


/**
 * Returns whether this field is set.
 * @return {boolean}
 */
proto.playbook.RunPlaybookRequest.prototype.hasPlaybookInputs = function() {
  return jspb.Message.getField(this, 1) != null;
};


/**
 * optional bool is_visible_in_chat = 2;
 * @return {boolean}
 */
proto.playbook.RunPlaybookRequest.prototype.getIsVisibleInChat = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.playbook.RunPlaybookRequest} returns this
 */
proto.playbook.RunPlaybookRequest.prototype.setIsVisibleInChat = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};


/**
 * optional string optional_question = 3;
 * @return {string}
 */
proto.playbook.RunPlaybookRequest.prototype.getOptionalQuestion = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 3, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.RunPlaybookRequest} returns this
 */
proto.playbook.RunPlaybookRequest.prototype.setOptionalQuestion = function(value) {
  return jspb.Message.setProto3StringField(this, 3, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.RunPlaybookResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.RunPlaybookResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.RunPlaybookResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.RunPlaybookResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    chatId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    taskId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.RunPlaybookResponse}
 */
proto.playbook.RunPlaybookResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.RunPlaybookResponse;
  return proto.playbook.RunPlaybookResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.RunPlaybookResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.RunPlaybookResponse}
 */
proto.playbook.RunPlaybookResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setTaskId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.RunPlaybookResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.RunPlaybookResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.RunPlaybookResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.RunPlaybookResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getTaskId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string chat_id = 1;
 * @return {string}
 */
proto.playbook.RunPlaybookResponse.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.RunPlaybookResponse} returns this
 */
proto.playbook.RunPlaybookResponse.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string task_id = 2;
 * @return {string}
 */
proto.playbook.RunPlaybookResponse.prototype.getTaskId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.RunPlaybookResponse} returns this
 */
proto.playbook.RunPlaybookResponse.prototype.setTaskId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.IsHeadlessChatRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.IsHeadlessChatRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.IsHeadlessChatRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.IsHeadlessChatRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    accountId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    chatId: jspb.Message.getFieldWithDefault(msg, 2, "")
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.IsHeadlessChatRequest}
 */
proto.playbook.IsHeadlessChatRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.IsHeadlessChatRequest;
  return proto.playbook.IsHeadlessChatRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.IsHeadlessChatRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.IsHeadlessChatRequest}
 */
proto.playbook.IsHeadlessChatRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setAccountId(value);
      break;
    case 2:
      var value = /** @type {string} */ (reader.readString());
      msg.setChatId(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.IsHeadlessChatRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.IsHeadlessChatRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.IsHeadlessChatRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.IsHeadlessChatRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getAccountId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getChatId();
  if (f.length > 0) {
    writer.writeString(
      2,
      f
    );
  }
};


/**
 * optional string account_id = 1;
 * @return {string}
 */
proto.playbook.IsHeadlessChatRequest.prototype.getAccountId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.IsHeadlessChatRequest} returns this
 */
proto.playbook.IsHeadlessChatRequest.prototype.setAccountId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional string chat_id = 2;
 * @return {string}
 */
proto.playbook.IsHeadlessChatRequest.prototype.getChatId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 2, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.IsHeadlessChatRequest} returns this
 */
proto.playbook.IsHeadlessChatRequest.prototype.setChatId = function(value) {
  return jspb.Message.setProto3StringField(this, 2, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.IsHeadlessChatResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.IsHeadlessChatResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.IsHeadlessChatResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.IsHeadlessChatResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    isHeadless: jspb.Message.getBooleanFieldWithDefault(msg, 1, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.IsHeadlessChatResponse}
 */
proto.playbook.IsHeadlessChatResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.IsHeadlessChatResponse;
  return proto.playbook.IsHeadlessChatResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.IsHeadlessChatResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.IsHeadlessChatResponse}
 */
proto.playbook.IsHeadlessChatResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsHeadless(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.IsHeadlessChatResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.IsHeadlessChatResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.IsHeadlessChatResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.IsHeadlessChatResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getIsHeadless();
  if (f) {
    writer.writeBool(
      1,
      f
    );
  }
};


/**
 * optional bool is_headless = 1;
 * @return {boolean}
 */
proto.playbook.IsHeadlessChatResponse.prototype.getIsHeadless = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 1, false));
};


/**
 * @param {boolean} value
 * @return {!proto.playbook.IsHeadlessChatResponse} returns this
 */
proto.playbook.IsHeadlessChatResponse.prototype.setIsHeadless = function(value) {
  return jspb.Message.setProto3BooleanField(this, 1, value);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.MakePrivateRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.MakePrivateRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.MakePrivateRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.MakePrivateRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    playbookId: jspb.Message.getFieldWithDefault(msg, 1, ""),
    isPrivate: jspb.Message.getBooleanFieldWithDefault(msg, 2, false)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.MakePrivateRequest}
 */
proto.playbook.MakePrivateRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.MakePrivateRequest;
  return proto.playbook.MakePrivateRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.MakePrivateRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.MakePrivateRequest}
 */
proto.playbook.MakePrivateRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = /** @type {string} */ (reader.readString());
      msg.setPlaybookId(value);
      break;
    case 2:
      var value = /** @type {boolean} */ (reader.readBool());
      msg.setIsPrivate(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.MakePrivateRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.MakePrivateRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.MakePrivateRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.MakePrivateRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getPlaybookId();
  if (f.length > 0) {
    writer.writeString(
      1,
      f
    );
  }
  f = message.getIsPrivate();
  if (f) {
    writer.writeBool(
      2,
      f
    );
  }
};


/**
 * optional string playbook_id = 1;
 * @return {string}
 */
proto.playbook.MakePrivateRequest.prototype.getPlaybookId = function() {
  return /** @type {string} */ (jspb.Message.getFieldWithDefault(this, 1, ""));
};


/**
 * @param {string} value
 * @return {!proto.playbook.MakePrivateRequest} returns this
 */
proto.playbook.MakePrivateRequest.prototype.setPlaybookId = function(value) {
  return jspb.Message.setProto3StringField(this, 1, value);
};


/**
 * optional bool is_private = 2;
 * @return {boolean}
 */
proto.playbook.MakePrivateRequest.prototype.getIsPrivate = function() {
  return /** @type {boolean} */ (jspb.Message.getBooleanFieldWithDefault(this, 2, false));
};


/**
 * @param {boolean} value
 * @return {!proto.playbook.MakePrivateRequest} returns this
 */
proto.playbook.MakePrivateRequest.prototype.setIsPrivate = function(value) {
  return jspb.Message.setProto3BooleanField(this, 2, value);
};



/**
 * List of repeated fields within this message type.
 * @private {!Array<number>}
 * @const
 */
proto.playbook.UploadFilesRequest.repeatedFields_ = [1];



if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.UploadFilesRequest.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.UploadFilesRequest.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.UploadFilesRequest} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.UploadFilesRequest.toObject = function(includeInstance, msg) {
  var f, obj = {
    fileUploadsList: jspb.Message.toObjectList(msg.getFileUploadsList(),
    common_model_pb.FileUploadBody.toObject, includeInstance)
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.UploadFilesRequest}
 */
proto.playbook.UploadFilesRequest.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.UploadFilesRequest;
  return proto.playbook.UploadFilesRequest.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.UploadFilesRequest} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.UploadFilesRequest}
 */
proto.playbook.UploadFilesRequest.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 1:
      var value = new common_model_pb.FileUploadBody;
      reader.readMessage(value,common_model_pb.FileUploadBody.deserializeBinaryFromReader);
      msg.addFileUploads(value);
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.UploadFilesRequest.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.UploadFilesRequest.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.UploadFilesRequest} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.UploadFilesRequest.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getFileUploadsList();
  if (f.length > 0) {
    writer.writeRepeatedMessage(
      1,
      f,
      common_model_pb.FileUploadBody.serializeBinaryToWriter
    );
  }
};


/**
 * repeated common.FileUploadBody file_uploads = 1;
 * @return {!Array<!proto.common.FileUploadBody>}
 */
proto.playbook.UploadFilesRequest.prototype.getFileUploadsList = function() {
  return /** @type{!Array<!proto.common.FileUploadBody>} */ (
    jspb.Message.getRepeatedWrapperField(this, common_model_pb.FileUploadBody, 1));
};


/**
 * @param {!Array<!proto.common.FileUploadBody>} value
 * @return {!proto.playbook.UploadFilesRequest} returns this
*/
proto.playbook.UploadFilesRequest.prototype.setFileUploadsList = function(value) {
  return jspb.Message.setRepeatedWrapperField(this, 1, value);
};


/**
 * @param {!proto.common.FileUploadBody=} opt_value
 * @param {number=} opt_index
 * @return {!proto.common.FileUploadBody}
 */
proto.playbook.UploadFilesRequest.prototype.addFileUploads = function(opt_value, opt_index) {
  return jspb.Message.addToRepeatedWrapperField(this, 1, opt_value, proto.common.FileUploadBody, opt_index);
};


/**
 * Clears the list making it empty but non-null.
 * @return {!proto.playbook.UploadFilesRequest} returns this
 */
proto.playbook.UploadFilesRequest.prototype.clearFileUploadsList = function() {
  return this.setFileUploadsList([]);
};





if (jspb.Message.GENERATE_TO_OBJECT) {
/**
 * Creates an object representation of this proto.
 * Field names that are reserved in JavaScript and will be renamed to pb_name.
 * Optional fields that are not set will be set to undefined.
 * To access a reserved field use, foo.pb_<name>, eg, foo.pb_default.
 * For the list of reserved names please see:
 *     net/proto2/compiler/js/internal/generator.cc#kKeyword.
 * @param {boolean=} opt_includeInstance Deprecated. whether to include the
 *     JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @return {!Object}
 */
proto.playbook.UploadFilesResponse.prototype.toObject = function(opt_includeInstance) {
  return proto.playbook.UploadFilesResponse.toObject(opt_includeInstance, this);
};


/**
 * Static version of the {@see toObject} method.
 * @param {boolean|undefined} includeInstance Deprecated. Whether to include
 *     the JSPB instance for transitional soy proto support:
 *     http://goto/soy-param-migration
 * @param {!proto.playbook.UploadFilesResponse} msg The msg instance to transform.
 * @return {!Object}
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.UploadFilesResponse.toObject = function(includeInstance, msg) {
  var f, obj = {
    contentIdsMap: (f = msg.getContentIdsMap()) ? f.toObject(includeInstance, undefined) : []
  };

  if (includeInstance) {
    obj.$jspbMessageInstance = msg;
  }
  return obj;
};
}


/**
 * Deserializes binary data (in protobuf wire format).
 * @param {jspb.ByteSource} bytes The bytes to deserialize.
 * @return {!proto.playbook.UploadFilesResponse}
 */
proto.playbook.UploadFilesResponse.deserializeBinary = function(bytes) {
  var reader = new jspb.BinaryReader(bytes);
  var msg = new proto.playbook.UploadFilesResponse;
  return proto.playbook.UploadFilesResponse.deserializeBinaryFromReader(msg, reader);
};


/**
 * Deserializes binary data (in protobuf wire format) from the
 * given reader into the given message object.
 * @param {!proto.playbook.UploadFilesResponse} msg The message object to deserialize into.
 * @param {!jspb.BinaryReader} reader The BinaryReader to use.
 * @return {!proto.playbook.UploadFilesResponse}
 */
proto.playbook.UploadFilesResponse.deserializeBinaryFromReader = function(msg, reader) {
  while (reader.nextField()) {
    if (reader.isEndGroup()) {
      break;
    }
    var field = reader.getFieldNumber();
    switch (field) {
    case 2:
      var value = msg.getContentIdsMap();
      reader.readMessage(value, function(message, reader) {
        jspb.Map.deserializeBinary(message, reader, jspb.BinaryReader.prototype.readString, jspb.BinaryReader.prototype.readString, null, "", "");
         });
      break;
    default:
      reader.skipField();
      break;
    }
  }
  return msg;
};


/**
 * Serializes the message to binary data (in protobuf wire format).
 * @return {!Uint8Array}
 */
proto.playbook.UploadFilesResponse.prototype.serializeBinary = function() {
  var writer = new jspb.BinaryWriter();
  proto.playbook.UploadFilesResponse.serializeBinaryToWriter(this, writer);
  return writer.getResultBuffer();
};


/**
 * Serializes the given message to binary data (in protobuf wire
 * format), writing to the given BinaryWriter.
 * @param {!proto.playbook.UploadFilesResponse} message
 * @param {!jspb.BinaryWriter} writer
 * @suppress {unusedLocalVariables} f is only used for nested messages
 */
proto.playbook.UploadFilesResponse.serializeBinaryToWriter = function(message, writer) {
  var f = undefined;
  f = message.getContentIdsMap(true);
  if (f && f.getLength() > 0) {
    f.serializeBinary(2, writer, jspb.BinaryWriter.prototype.writeString, jspb.BinaryWriter.prototype.writeString);
  }
};


/**
 * map<string, string> content_ids = 2;
 * @param {boolean=} opt_noLazyCreate Do not create the map if
 * empty, instead returning `undefined`
 * @return {!jspb.Map<string,string>}
 */
proto.playbook.UploadFilesResponse.prototype.getContentIdsMap = function(opt_noLazyCreate) {
  return /** @type {!jspb.Map<string,string>} */ (
      jspb.Message.getMapField(this, 2, opt_noLazyCreate,
      null));
};


/**
 * Clears values from the map. The map will be non-null.
 * @return {!proto.playbook.UploadFilesResponse} returns this
 */
proto.playbook.UploadFilesResponse.prototype.clearContentIdsMap = function() {
  this.getContentIdsMap().clear();
  return this;};


/**
 * @enum {number}
 */
proto.playbook.ValueSource = {
  VALUE_SOURCE_USE_DEFAULTS: 0,
  VALUE_SOURCE_ASK_USER: 1
};

/**
 * @enum {number}
 */
proto.playbook.TrusteroAgentType = {
  TRUSTERO_AGENT_TYPE_NONE: 0,
  TRUSTERO_AGENT_TYPE_AUDIT_SCAN: 1
};

goog.object.extend(exports, proto.playbook);
